import xhr from 'xhr'
import xtend from 'xtend'
import urlJoin from 'url-join'
import slug from '@invintusmedia/slug'

export const slugify = (str) => {
    return slug(str, {
        replacement: '-',
        lower: false,
        remove: null,
        charmap: xtend(slug.charmap, {
            '_': '-'
        })
    });
}

export const createRequestFn = ({ clientID, host, headers }) => {
    // pass a pathname, return a function of (params, cb)
    // convenient way to make xhr fns with a signature of (body, cb)
    return function request (urlPath) {
        return function (body, cb) {
            xhr.post({
                url: urlJoin(host, urlPath),
                headers,
                body: xtend({ clientID }, body),
                json: true
            }, function (err, res, body) {
                if (err) return cb(err)
                if (('' + res.statusCode)[0] != '2') return cb(new Error(
                    res.statusMessage || res.statusCode))

                var _err
                try {
                    if (body.errors.hasError) {
                        var msg = (typeof body.errors.message === 'string' ?
                            body.errors.message :
                            body.errors.message[0])
                        _err = new Error(msg)
                    }
                } catch (__err) {
                    // ok
                }

                if (_err) return cb(_err)
                cb(null, body)
            })
        }
    }
}

